module.exports = "fonts/GilroyRegular.woff";